export const queryKeys = {
  profileInfo: {
    root: ['profile-info'],
  },
  webinar: {
    root: ['webinar'],
    attendees: (id: string) => ['webinar-attendees', id],
    attendeesPaginated: (id: string) => ['webinar-attendees-paginated', id],
    attendeesFilters: (id: string) => ['attendeesFilters', id],
    listMeeting: ['scheduled-meetings'],
    questions: ['questions'],
    myQuestions: ['my-questions'],
    questionReply: (id: string) => ['questionReply', id],
    // CTA
    ctas: (roomId: string) => ['ctas', roomId],
  },
  calculator: {
    currencyList: ['currencyList'],
    exchangeRates: (source: string) => ['exchangeRates', source],
  },
  meet: {
    roomData: (roomId: string) => ['room', roomId],
  },
};
